export default __webpack_public_path__ + "static/media/cours-particulier-learn-english.d76c310b.webp";